import { useState } from "react";
import { Link } from "react-router-dom";
import { staffLogin, kioskTerminalReaders, kioskSetDefaultReader } from "@/lib/api";

export const KIOSK_READER_KEY = "naami_kiosk_reader";
export const getKioskReader = () => {
    try { return JSON.parse(localStorage.getItem(KIOSK_READER_KEY) || "null"); } catch { return null; }
};

export default function KioskSetup() {
    const [pin, setPin] = useState("");
    const [token, setToken] = useState(null);
    const [readers, setReaders] = useState(null);
    const [current, setCurrent] = useState(getKioskReader());
    const [err, setErr] = useState("");

    const unlock = async () => {
        setErr("");
        try {
            const s = await staffLogin(pin);
            setToken(s.token);
            const r = await kioskTerminalReaders(s.token);
            setReaders(r.readers);
        } catch (e) {
            setErr(e.response?.data?.detail || "Wrong PIN");
        }
    };
    const pick = async (r) => {
        const v = { id: r.id, label: r.label };
        localStorage.setItem(KIOSK_READER_KEY, JSON.stringify(v));
        setCurrent(v);
        try { await kioskSetDefaultReader(token, v); } catch (e) { setErr(e.response?.data?.detail || "Couldn't save the reader for all kiosks"); }
    };
    const clear = () => { localStorage.removeItem(KIOSK_READER_KEY); setCurrent(null); };

    return (
        <div className="min-h-screen bg-[var(--bg)] text-[var(--text)] grid place-items-center p-6" data-testid="kiosk-setup">
            <div className="w-full max-w-md border border-[var(--border)] bg-[var(--surface)] p-7">
                <p className="eyebrow">// Kiosk setup</p>
                <h1 className="font-display text-[34px] leading-none mt-2 mb-5">Card reader for this iPad</h1>
                <p className="font-mono text-[11px] uppercase tracking-[0.16em] mb-5" data-testid="kiosk-setup-current">
                    Current: <span className={current ? "text-gold" : "text-[#ff5246]"}>{current ? current.label : "none — kiosk can't take cards"}</span>
                </p>
                {!token ? (
                    <div className="space-y-3">
                        <input className="input text-center text-2xl tracking-[0.5em]" type="password" inputMode="numeric" maxLength={6} value={pin}
                            onChange={(e) => setPin(e.target.value.replace(/\D/g, ""))} placeholder="Staff PIN" data-testid="kiosk-setup-pin" />
                        <button className="btn-primary w-full justify-center" disabled={pin.length < 4} onClick={unlock} data-testid="kiosk-setup-unlock">Unlock</button>
                    </div>
                ) : readers?.length === 0 ? (
                    <p className="text-muted text-sm">No readers registered yet — add one in Admin → 💳 Card readers.</p>
                ) : (
                    <div className="space-y-2">
                        {readers?.map((r) => (
                            <button key={r.id} onClick={() => pick(r)}
                                className={`w-full flex items-center justify-between border px-4 py-3 ${current?.id === r.id ? "border-[var(--gold)] bg-[var(--gold)]/10" : "border-[var(--border)]"}`}
                                data-testid={`kiosk-setup-reader-${r.id}`}>
                                <span>{r.label}</span>
                                <span className={`font-mono text-[10px] uppercase ${r.status === "online" ? "text-[#1f9d55]" : "text-[#ff5246]"}`}>{r.status}</span>
                            </button>
                        ))}
                        {current && <button className="font-mono text-[10px] uppercase tracking-[0.16em] text-muted mt-2" onClick={clear} data-testid="kiosk-setup-clear">Unlink this iPad</button>}
                    </div>
                )}
                {err && <p className="font-mono text-[11px] text-[#ff5246] mt-3" data-testid="kiosk-setup-error">{err}</p>}
                <Link to="/kiosk" className="btn-secondary w-full flex justify-center mt-6" data-testid="kiosk-setup-done">Back to kiosk →</Link>
            </div>
        </div>
    );
}
